import { create } from 'zustand';

interface LoadingStoreState {
  loadingState: {
    loading: boolean;
    count: number;
  };
  setLoading: (loadingState: { loading: boolean; count: number }) => void;
}

const useLoadingStore = create<LoadingStoreState>((set) => {
  return {
    loadingState: {
      loading: false,
      count: 0,
    },
    setLoading: (loadingState) => {
      return set(() => {
        return { loadingState };
      });
    },
  };
});

export { useLoadingStore };
